import React from "react";

export default ({ color = "#FFF", grey = false }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M8,8 L8,3 L10,3 L10,8 L15,8 L15,10 L10,10 L10,15 L8,15 L8,10 L3,10 L3,8 L8,8 Z"
        id="path-closebutton"
      />
    </defs>
    <g
      id="Icon/Other/Close-Button"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
    >
      <mask id="mask-closebutton" fill="white">
        <use xlinkHref="#path-closebutton" />
      </mask>
      <use
        id="Close-Button"
        fillOpacity={0}
        fill="#FFFFFF"
        transform="translate(9.000000, 9.000000) rotate(-315.000000) translate(-9.000000, -9.000000) "
        xlinkHref="#path-closebutton"
      />
      <g
        id="⚙️Atoms/Colour/White/1---100%"
        mask="url(#mask-closebutton)"
        fill={grey ? "#CCCDD1" : color}
        transform="translate(9.000000, 9.000000) rotate(-315.000000) translate(-9.000000, -9.000000) "
      >
        <rect id="Rectangle" x={0} y={0} width={18} height={18} />
      </g>
    </g>
  </svg>
);
